import React from 'react';
import { OverlayDrawerComponentProps, PiletApi } from '@sharefiledev/sharefile-appshell';

export interface ExtensionProps {
	piral: PiletApi;
}

const LazyCreateProjectOverlayContent = React.lazy(
	() => import('./CreateProjectOverlayContent')
);
export const CreateProjectOverlay: React.FC<
	OverlayDrawerComponentProps<'urn:drawer:projects-pilet:create-project'>
> = props => {
	return (
		<React.Suspense fallback={<div data-testid="loading-create-project-drawer" />}>
			<LazyCreateProjectOverlayContent
				{...props}
				pendoTrackingNamespace={props?.options?.pendoTrackingNamespace}
			/>
		</React.Suspense>
	);
};

const LazySuggestedProjectsDrawer = React.lazy(
	() => import('./SuggestedProjectsOverlay/SuggestedProjectsDrawer')
);
export const SuggestedProjectsOverlay: React.FC<
	OverlayDrawerComponentProps<'urn:drawer:projects-pilet:suggested-projects'>
> = props => {
	if (!props || !props?.options?.suggestedProjects) {
		return <div data-testid="suggested-projects-drawer-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-suggested-projects-drawer" />}>
			<LazySuggestedProjectsDrawer
				suggestedProjects={props.options.suggestedProjects}
				verticalContextKey={props.options.verticalContextKey}
				{...props}
			/>
		</React.Suspense>
	);
};
